// extracted by mini-css-extract-plugin
module.exports = {"dropArea":"DropArea-module_dropArea_OyFhT","show":"DropArea-module_show_2ioGL","message":"DropArea-module_message_2Jt6T","oversize":"DropArea-module_oversize_3QcZc"};